/**
 *  @class
 *  @function FlashMessage
 */
if (!customElements.get('flash-message')) {
  class FlashMessage extends HTMLElement {
    constructor() {
      super();
      this.close_button = this.querySelector('button');
      this.id = this.dataset.id;
      this.isHypestoreStoreCheck = this.dataset.hypestoreCheck;
      this.hypestoreVisible = this.dataset.hypestoreVisible;
      this.close_behaviour = this.dataset.closeButton;
      this.flashMessages = JSON.parse(window.sessionStorage.getItem('flash-messages')) || [];
    }

    connectedCallback() {
      if (this.close_behaviour == 'close_forever') {
        if (this.flashMessages && this.flashMessages?.includes(this.id)) {
          return;
        }
      }
      this.removeAttribute('hidden');
      this.close_button?.addEventListener('click', this.onClick.bind(this));

      if (this.isHypestoreStoreCheck == "1") {
        this.dataset.hypestoreVisible = "0";
        this.detectVariantType();
        document.addEventListener('change', (e) => {
          if (e.target.matches('[name="Tailles"]')) this.detectVariantType('[name="Tailles"]');
          else if (e.target.matches('[name="Tailles--sticky"]')) this.detectVariantType('[name="Tailles--sticky"]');
        });
      }
    }

    onClick() {
      if (this.close_behaviour == 'close_forever') {
        this.flashMessages.unshift(this.id);
        window.sessionStorage.setItem('flash-messages', JSON.stringify(this.flashMessages));
      }
      this.remove();
    }

    detectVariantType(name) {
      const selected = document.querySelector(name + ':checked');
      if (!selected) return;

      const label = document.querySelector(`label[for="${selected.id}"]`);
      if (!label) return;

      if (label.classList.contains('location-drop')) this.dataset.hypestoreVisible = "0";
      else if (label.classList.contains('location-store')) this.dataset.hypestoreVisible = "1";
      else this.dataset.hypestoreVisible = "0";
    }
  }
  customElements.define('flash-message', FlashMessage);
}
